document.documentElement.classList.remove("no-js");
document.addEventListener("DOMContentLoaded", function () {
    const toggle = document.querySelector(".atl-menu-toggle");
    const links = document.querySelector(".atl-nav__links");

    if (toggle && links) {
        toggle.addEventListener("click", function () {
            const isOpen = links.classList.toggle("is-open");
            toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        });

        links.addEventListener("click", function (event) {
            if (event.target.closest("a")) {
                links.classList.remove("is-open");
                toggle.setAttribute("aria-expanded", "false");
            }
        });
    }

    /* Shopify cart behaviour mirroring the WooCommerce AJAX add-to-cart flow. */
    function addToCart(variantId, quantity) {
        return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] })
        }).then(function (r) {
            return r.json().then(function (data) {
                if (!r.ok) { throw new Error(data.description || data.message || "Unable to add to cart"); }
                return data;
            });
        });
    }

    document.addEventListener("click", function (event) {
        const button = event.target.closest("[data-atl-add]");
        if (!button) { return; }
        event.preventDefault();
        if (button.classList.contains("loading")) { return; }
        button.classList.add("loading");
        addToCart(button.getAttribute("data-variant-id"), 1).then(function () {
            button.classList.remove("loading");
            button.classList.add("added");
            if (!button.parentNode.querySelector(".added_to_cart")) {
                const view = document.createElement("a");
                view.href = "/cart";
                view.className = "added_to_cart wc-forward";
                view.title = "View cart";
                view.textContent = "View cart";
                button.insertAdjacentElement("afterend", view);
            }
        }).catch(function (error) {
            button.classList.remove("loading");
            window.alert(error.message);
        });
    });

    document.querySelectorAll("form[data-atl-product-form]").forEach(function (form) {
        form.addEventListener("submit", function (event) {
            event.preventDefault();
            const submit = form.querySelector("[type=submit]");
            const id = form.querySelector("[name=id]").value;
            const qty = form.querySelector("[name=quantity]") ? form.querySelector("[name=quantity]").value : 1;
            if (submit) { submit.classList.add("loading"); }
            addToCart(id, qty).then(function () {
                const wrapper = document.querySelector(".woocommerce-notices-wrapper");
                if (wrapper) {
                    wrapper.innerHTML = "";
                    const notice = document.createElement("div");
                    notice.className = "woocommerce-message";
                    notice.setAttribute("role", "alert");
                    const view = document.createElement("a");
                    view.href = "/cart";
                    view.className = "button wc-forward";
                    view.textContent = "View cart";
                    notice.appendChild(view);
                    notice.appendChild(document.createTextNode(" " + (qty > 1 ? qty + " × " : "") + "\u201C" + form.getAttribute("data-product-title") + "\u201D " + (qty > 1 ? "have" : "has") + " been added to your cart."));
                    wrapper.appendChild(notice);
                    wrapper.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }).catch(function (error) {
                window.alert(error.message);
            }).finally(function () {
                if (submit) { submit.classList.remove("loading"); }
            });
        });
    });

    document.querySelectorAll("[data-atl-tabs]").forEach(function (tabs) {
        tabs.querySelectorAll(".wc-tabs a").forEach(function (link) {
            link.addEventListener("click", function (event) {
                event.preventDefault();
                tabs.querySelectorAll(".wc-tabs li").forEach(function (li) { li.classList.remove("active"); });
                tabs.querySelectorAll(".wc-tab").forEach(function (panel) { panel.style.display = "none"; });
                link.parentNode.classList.add("active");
                const panel = tabs.querySelector(link.getAttribute("href"));
                if (panel) { panel.style.display = ""; }
            });
        });
    });

    document.querySelectorAll("select[data-atl-sort]").forEach(function (select) {
        select.addEventListener("change", function () {
            const url = new URL(window.location.href);
            url.searchParams.set("sort_by", select.value);
            url.searchParams.delete("page");
            window.location.href = url.toString();
        });
    });

    document.querySelectorAll("[data-atl-qty]").forEach(function (wrap) {
        const input = wrap.querySelector("input");
        wrap.querySelectorAll("button").forEach(function (btn) {
            btn.addEventListener("click", function () {
                const step = btn.hasAttribute("data-minus") ? -1 : 1;
                input.value = Math.max(0, (parseInt(input.value, 10) || 0) + step);
                input.form.submit();
            });
        });
    });

    document.querySelectorAll("[data-atl-coupon-toggle]").forEach(function (btn) {
        btn.addEventListener("click", function () {
            const panel = document.getElementById(btn.getAttribute("aria-controls"));
            const open = btn.getAttribute("aria-expanded") !== "true";
            btn.setAttribute("aria-expanded", open ? "true" : "false");
            if (panel) { panel.hidden = !open; }
        });
    });

    document.querySelectorAll("[data-atl-gallery] .flex-control-thumbs img").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
            const gallery = thumb.closest("[data-atl-gallery]");
            const main = gallery.querySelector("[data-atl-main-image]");
            const link = gallery.querySelector("[data-atl-main-link]");
            if (main) { main.src = thumb.getAttribute("data-full"); main.alt = thumb.alt; }
            if (link) { link.href = thumb.getAttribute("data-large"); }
            gallery.querySelectorAll(".flex-control-thumbs img").forEach(function (img) { img.classList.remove("flex-active"); });
            thumb.classList.add("flex-active");
        });
    });

    document.querySelectorAll(".wc-block-components-totals-coupon__button").forEach(function (btn) {
        btn.addEventListener("click", function (event) {
            const input = document.getElementById("atl-coupon");
            if (!input || !input.value.trim()) { return; }
            event.preventDefault();
            window.location.href = "/checkout?discount=" + encodeURIComponent(input.value.trim());
        });
    });

    document.querySelectorAll(".atl-quote-form .atl-form-message").forEach(function (message) {
        const form = message.closest("form");
        form.parentNode.insertBefore(message, form);
    });
    if (document.querySelector(".atl-quote-form-section .atl-form-message") && window.location.hash !== "#quote") {
        const section = document.getElementById("quote");
        if (section) { section.scrollIntoView(); }
    }
});

/* Variant selector: show selected variation price (WooCommerce single_variation behaviour) */
document.addEventListener("change", function (event) {
    const select = event.target.closest("#atl-variant");
    if (!select) { return; }
    const option = select.options[select.selectedIndex];
    const target = select.closest("form").querySelector("[data-atl-variant-price]");
    if (option && target && option.dataset.price) { target.textContent = option.dataset.price; }
});
